export default __webpack_public_path__ + "static/media/Architect.bc5a70bd.jpeg";